/* tempexp_18086-start */
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { BillingDataReferralSelectors } from 'reactApp/modules/billingData/billingData.referral.selectors';
import { renderReferralModal } from 'reactApp/ui/ReferralProgram/ReferralModal/ReferralModal.helpers';

export function useRefferalModalHandlers() {
    const referralQuota = useSelector(BillingDataReferralSelectors.getReferralCommonQuota);
    const referralList = useSelector(BillingDataReferralSelectors.sortReferralsByExpires);

    const showModal = useCallback(() => {
        renderReferralModal({
            quota: referralQuota,
            list: referralList,
            isReturn: false,
        });
    }, [referralQuota, referralList]);
    return { referralQuota, showModal } as const;
}

/* tempexp_18086-end */
